import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import { exportOrders, OrderType } from "@/hooks/useOrders";
import { ReactNode } from "react";

export default function ExportOrdersAction({
  orderType,
  year,
  children,
  onSuccess,
}: {
  orderType: OrderType;
  year?: number;
  children: ReactNode;
  onSuccess?: () => void;
}) {
  return (
    <ActionsPopover
      actions={
        <>
          <FileDownloader
            fileOutputName={`export-${orderType}.xlsx`}
            fileUrlFn={() => exportOrders({ type: orderType })}
            onFinish={onSuccess}
            addTimestampAndCompany={true}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export all
              </ActionsPopOverItem>
            )}
          />
          <FileDownloader
            fileOutputName={`export-${orderType}-${year}.xlsx`}
            fileUrlFn={() => exportOrders({ type: orderType, year })}
            onFinish={onSuccess}
            addTimestampAndCompany={true}
            customRender={(props) => (
              <ActionsPopOverItem
                {...props}
                black
              >
                Export {year}
              </ActionsPopOverItem>
            )}
          />
        </>
      }
    >
      {children}
    </ActionsPopover>
  );
}
